<template>
    <section class="block prod-cat">
        <div class="wrap">
            <div class="prod-shell">
                <Filters v-model="filters" @reset="resetFilters" />

                <div class="prod-main">
                    <div class="pm-top">
                        <div class="prod-count">{{ countLabel }}</div>
                        <Pagination v-model="filters" :meta="meta" />
                    </div>

                    <div class="prod-cat-grid">
                        <template v-if="loading">
                            <div v-for="n in skeletonCount" :key="'sk' + n" class="prod-card prod-card--sk" aria-hidden="true">
                                <div class="pc-img rb-sk"></div>
                                <div class="rb-sk rb-sk-line" style="width:75%"></div>
                                <div class="rb-sk rb-sk-line rb-sk-line--sm" style="width:95%"></div>
                                <div class="pc-foot"><span class="rb-sk rb-sk-line rb-sk-line--price"></span></div>
                            </div>
                        </template>
                        <ProductCard v-else v-for="product in products" :key="product.id" :product="product" />
                    </div>

                    <div class="prod-empty" :class="{ show: !loading && products.length === 0 }">
                        No hay productos con estos filtros todavía.
                    </div>

                    <Pagination v-model="filters" :meta="meta" class="pagination-bottom" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Filters from './Filters.vue';
import Pagination from './Pagination.vue';
import ProductCard from './ProductCard.vue';

export default {
    inject: ['axios', 'locale'],
    components: { Filters, ProductCard, Pagination },

    data() {
        return {
            products: [],
            meta: {},
            loading: true,
            filters: {
                page_size: 6,
                page: 1,
                include: 'categories,thumbnail',
                locale: this.locale
            }
        }
    },

    computed: {
        countLabel() {
            const total = Number(this.meta?.total ?? this.products.length) || 0
            return total + (total === 1 ? ' producto' : ' productos')
        },
        skeletonCount() {
            return Number(this.filters.page_size) || 6
        }
    },

    watch: {
        filters: {
            handler: function (value) {
                this.getProducts()
            },
            deep: true,
            immediate: true
        }
    },

    methods: {
        getProducts() {
            this.loading = true
            this.axios.get('/products', {
                params: this.filters
            }).then(r => {
                this.products = r.data.data
                this.meta = r.data.meta
            }).catch(e => {
                console.warn(e)
            }).finally(() => {
                this.loading = false
            })
        },

        resetFilters() {
            this.filters = {
                page_size: this.filters.page_size,
                page: 1,
                include: 'categories,thumbnail',
                locale: this.locale
            }
        }
    }
}
</script>

<style>
/* Skeleton loaders del catálogo (mientras carga la API) */
.prod-card--sk{cursor:default;pointer-events:none;}
.rb-sk{position:relative;overflow:hidden;background:#ece6e2;border-radius:8px;}
.rb-sk::after{content:"";position:absolute;inset:0;transform:translateX(-100%);background:linear-gradient(90deg,transparent,rgba(255,255,255,.65),transparent);animation:rbSkShimmer 1.3s ease-in-out infinite;}
.prod-card--sk .pc-img.rb-sk{width:100%;}
.rb-sk-line{height:22px;margin-top:14px;border-radius:6px;}
.rb-sk-line--sm{height:16px;margin-top:10px;}
.rb-sk-line--price{display:inline-block;width:90px;height:20px;margin-top:0;}
@keyframes rbSkShimmer{to{transform:translateX(100%);}}
@media (prefers-reduced-motion:reduce){.rb-sk::after{animation:none;}}
</style>
